
<template>
  <div class="create-page " v-loading="loading">
    <div class="header mi_create_header_fixed p20" :style="{width: fixWidth}">
      <span class="close" @click="toListPage" v-matomo="{behaviorCategory: '小米(自动优化批量搭建)',  name: isCopy?'列表(复制-取消)':'批量创建(取消)' }"><i class="el-icon-back"></i>取消</span> |
      <span class="tip">批量创建</span>
      <el-popover
        placement="right-start"
        title="存在以下问题点，请检查修改后重试："
        width="400"
        trigger="manual"
        content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
        v-model="popoverVisible">
        <div class="tip-list">
          <p v-for="(item, index) in errorFormList" :key="index">
            {{index+1}}、{{item}}
          </p>
          <div class="btn"><el-button @click="popoverVisible = !popoverVisible" type="primary" size="mini"><span>关闭</span></el-button></div>
        </div>
        <el-button slot="reference" :loading="previewLoading" :disabled="appLoading || accountLoading" type="primary" size="mini" @click="toPreviewPage" v-matomo="{behaviorCategory: '小米(自动优化批量搭建)',  name: isCopy?'列表(复制-生成预览)':'批量创建(生成预览)' }">生成预览</el-button>
      </el-popover>

    </div>
    <div style="height: 80px;"></div>

    <div class="content-box" id="mi_create_body">
      <template v-if="showContent">
        <createInfo
          ref="createInfo"
          :campaign-type.sync="campaignTypeData"
          :account.sync="account"
          :defaData="getFormDate()"
          :account-list="accountList"
          :app-list="appList"
          :apps.sync="apps"
          :app-loading="appLoading"
          @updateAccount="getAccountDataList"
          @updateApp="getAppDataList"
          :displayType="displayTypeData"
          :account-loading="accountLoading"
          :addType="addType"
          :planName.sync="planName"
        />
        <advertGroup
          ref="advertGroup"
          :campaignType="campaignTypeData"
          :displayType.sync="displayTypeData"
          :userPackageDataList="userPackageDataList"
          :account="account"
          :adgroupName.sync="adgroupName"
          @updateUserList="handleUpdateUserList"
        />
        <advertCreat
          ref="advertCreat"
          :planAllocationRules.sync='planAllocationRules'
          :displayType="displayTypeData"
        />
        <crossProduct
          ref="crossProduct"
          :campaignType="campaignTypeData"
          :displayType="displayTypeData"
          :app-list="apps"
          :account="account"
          :addType.sync="addType"
        />
      </template>
    </div>
  </div>
</template>

<script>
import createInfo from '../components/createInfo.vue'
import advertGroup from '../components/advertGroup.vue'
import advertCreat from '../components/advertCreat.vue'
import crossProduct from '../components/crossProduct.vue'
// import configOption from '../modal/util'
import { mapGetters } from 'vuex'
import API from '@/api/marketManage/miBatchAuto'
import { cloneDeep } from 'lodash'
export default {
  components: { createInfo, advertGroup, advertCreat, crossProduct },
    props:{
      dataId:String,
      getFormDate: Function
    },

  data() {
    return {
      showContent: false,
      campaignTypeData: [],//投放范围选中的数据
      displayTypeData: [],//选中的版位数据
      accountList: [],//目标账户
      accountLoading: false,
      loading: false,
      appList:[],//产品列表
      apps: [],//选中的产品列表
      appLoading: false,
      configOption: {},//配置数据
      userPackageDataList: [],//定向人群
      account: '',//账户
      previewLoading: false,//预览
      fixWidth: '1000px',
      errorFormList: [],//表单验证错误数据
      popoverVisible: false,//
      addType: 1,//添加方式 1 按版位 默认   2 按产品+版位
      planName: '',//计划名称
      adgroupName: '',//广告组名称
      planAllocationRules:[],//计划分配规则
      TIP_DATA: {
        CV_TIP: '您当前计划/广告组的分配规则未选择【转化类型】，但名称通配符中包含【转化名称】，建议取消该通配符，否则可能会造成名称超长！',//转化类型取消提示
      }
    }
  },
   provide(){
    return{
        getOption:()=>{
          return this.configOption
        },
        validFormItem:(...data)=>this.validFormItem(...data),
        rulesCb: (...arg)=>this.rulesCb(...arg),
        nameCb: (...arg)=>this.nameCb(...arg),
    }
   },
  created() {
    this.getOptinData();

  },
  mounted() {
    this.getFixWidth()
    window.addEventListener('resize', this.getFixWidth);
  },
  computed:{
    ...mapGetters(['sidebar']),
      isCopy(){
          return !!this.dataId;
      }
  },
  watch:{
    account(n) {
      if (!n) {
        this.userPackageDataList = []
      }else {
        this.getUserPackageDataList(n)
      }
    },
    sidebar: {
      handler(n, o){
        console.log(n.opened)
        setTimeout(()=>{
          this.getFixWidth()
        }, 300)
      },
      deep: true
    }
  },
  methods: {
    getFixWidth() {
      let mi_create_body = document.getElementById('mi_create_body')
      if(mi_create_body) {
        let mi_width = mi_create_body.clientWidth
        this.fixWidth = `${mi_width}px`
      }
    },
    validFormItem(data) {
      this.errorFormList.push(data)
    },
    // form数据重新赋值
    updateFormData(data) {
      const { createInfoForm, advertGroupForm, advertCreatForm, crossProductForm, config } = cloneDeep( data|| this.getFormDate());
      this.addType = createInfoForm? (config?.add_type || 2) : 1;//没有就是按产品+版位  老数据

      this.$nextTick(()=> {
        createInfoForm&&this.$refs.createInfo?.setFormData( createInfoForm)
        advertGroupForm&&this.$refs.advertGroup?.setFormData(cloneDeep(advertGroupForm) )
        advertCreatForm&&this.$refs.advertCreat?.setFormData(advertCreatForm)
        crossProductForm&&this.$refs.crossProduct?.setFormData(crossProductForm)
      })
    },
    getOptinData() {
      this.loading = true
      Promise.all([
        this.getTaskInfoDataList(),
        this.getAccountDataList(),
        this.getConfigDataList()
      ]).then(([data])=> {
        this.showContent = true
        if (this.dataId) {
          this.updateFormData(data)
        }else {
          this.updateFormData()
        }
      })
      .finally(()=> {
        this.loading = false;
        this.showContent = true
      })
    },
    async getTaskInfoDataList() {
      if (this.dataId) {
        const params = {
          task_id: this.dataId
        }
        return await API.getTaskInfoDataList(params).then(({data})=> {
          const rule = data.plan_allocation_rules;
          const idea_group_list = data.idea_group_list;
          const {
            createInfoForm,
            advertGroupForm,
            advertCreatForm,
            crossProductForm,
            config
          } = JSON.parse(data.config_json)
          return {
            createInfoForm, advertGroupForm, config,
            advertCreatForm: {
              ...advertCreatForm,
              rule
            },
            crossProductForm: {
              ...crossProductForm,
              idea_group_list: JSON.stringify(idea_group_list)
            }
          }
        })
      }else {
        return {}
      }

    },
    // 获取账户
    async getAccountDataList(search='') {
      this.accountLoading = true
      const params = {
        search
      }
      return await API.getAccountDataList(params).then(({ data })=> {
         this.accountLoading = false
        this.accountList = data
      }).catch(()=>{
         this.accountLoading = false
      })
    },
    // 获取产品
    async getAppDataList(data) {
      this.appLoading = true
      const params = {
        ...data
      };
       return await API.getAppDataList(params).then(({ data })=> {
        this.appList = data.list
      }).catch(()=>{})
      .finally(()=> {
        this.appLoading = false
      })
    },
    // 获取配置选项信息
    async getConfigDataList() {
      return await API.getConfigDataList().then(({data})=> {
        const configObj = {};
        /**
         * campaign_type 投放范围
         * delivery_policy 投放方式 匀速投放 加速投放
         * wildcard_plan_name  计划名称 通配符
         * product_type 推广目的  ->  默认应用下载
         * display_type 投放版位 -> 商店-搜索 商店推荐等
         * ad_prod_type 广告形式 -> 普通广告 默认普通广告
         * installation 应用用户 -> 不限 已安装应用 未安装应用
         * wildcard_adgroup_name  广告组名称通配符
         * wildcard_ad_name  广告名称通配符
         * emi_material_type 素材规格
         * placement_type 创意类型
         *
         */
        data.map(item=> {
          const v = {
            ...item,
            required: +item.required
           }
          if (configObj[v.type]) {
            configObj[v.type].push(v)
          }else {
            configObj[v.type] = [v]
          }
        });
        this.configOption = configObj
        console.log("🚀 ~ returnawaitAPI.getConfigDataList ~ configObj:", configObj)
      })
    },
    // 获取定向人群
    async getUserPackageDataList(account_id) {
      const params = {
        account_id
      };
      const { data } = await API.getUserPackageDataList(params);
      this.userPackageDataList = data
    },
    // 更新定向人群
    async handleUpdateUserList(cb) {
        const vm = this.$notify({
          title: '请求成功',
          message: '正在更新，请稍等',
          type: 'success'
        });
        const params = {
          account_id: this.account
        }
       try {
         await API.postUpdateUserPackageDataList(params);

        this.$notify({
          title: '更新成功',
          message: '人群包 更新成功',
          type: 'success'
        });
        this.getUserPackageDataList(this.account)

       } catch (error) {
        if (typeof error.data === "number" && error.data>0) {
          cb(error.data)
        }
        this.$notify({
          title: '更新失败',
          message: error.info || '人群包 更新失败',
          type: 'error'
        });
        console.log('定向人群更新失败',error);
       }
      if (vm) {
        vm.close()
      }
    },
    toListPage() {
      if (this.account&&this.appList.length>0) {
         this.$confirm('取消后已经修改的内容不会保存，确认要取消吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
         this.$emit("changePage", "listPage")
        }).catch(() => {});
      }else {
        this.$emit("changePage", "listPage")
      }
    },
      async toPreviewPage(){
        this.previewLoading = true;
          this.errorFormList = [];
          Promise.all([
            this.$refs.createInfo.validateFn(),
            this.$refs.advertGroup.validateFn(),
            this.$refs.advertCreat.validateFn(),
            this.$refs.crossProduct.validateFn(),
          ]).then(async ([createInfoForm, advertGroupForm, advertCreatForm, crossProductForm])=> {
            const params = {
              account_id: createInfoForm.account,
              app_id: createInfoForm.product,
              campaign_type: createInfoForm.range,
              budget: createInfoForm.budget,
              delivery_policy: createInfoForm.mode,
              start_date: createInfoForm.startTime,//''
              end_date: createInfoForm.endTime,//''
              traffic_mode: createInfoForm.optimal?'1':'0',
              auto_optimize: createInfoForm.optimize?'1':'0',
              plan_name: createInfoForm.name,
              plan_status: createInfoForm.state?'1':'2',//计划状态（1-有效、2-暂停）
              scenario: createInfoForm.scene, //投放场景

              product_type: advertGroupForm.aim.toString(),//推广目的
              display_type: advertGroupForm.position,//投放版位
              group_type: advertGroupForm.way,//广告形式
              include_user_package: advertGroupForm.directCrowd,//定向人群
              exclude_user_package: advertGroupForm.excludeCrowd,//排除人群
              installation: advertGroupForm.user,//应用用户
              adgroup_name: advertGroupForm.name,//广告组名称
              adgroup_status: advertGroupForm.state?'1':'2',//广告组状态（1-有效、2-暂停）


              ad_name: advertCreatForm.name,//广告名称
              ad_status: advertCreatForm.state?'1':'2',//广告状态（1-有效、2-暂停）
              deep_link_url: advertCreatForm.deeplink,//deeplink地址
              click_monitor: advertCreatForm.cMonitorlink,//点击监测地址
              display_monitor: advertCreatForm.zMonitorlink,//展示监测地址
              // skip_one_stage: advertCreatForm.skip,//跳过一阶段
              is_derive: '0',//智能创意优选
              customized_url: '',//个性化详情⻚（推⼴目的为【应用下载】时可以填写，空串"" 表示使⽤应⽤详情⻚）
              description: '动态产品名称',//广告描述
              product_description: '动态产品名称',//推广产品描述
              brand: '动态产品名称',//广告品牌描述
              plan_allocation_rules: advertCreatForm.rule,//规则配置
              rta_token: advertCreatForm.RTAToken,//RTAToken
              channel_name: advertCreatForm.channelPackage,//渠道包
              description: advertCreatForm.description,
              product_description: advertCreatForm.product_description,
              brand: advertCreatForm.brand,


              conversion_bid_list: crossProductForm.conversion_bid_list,//转化出价
              idea_group_list: crossProductForm.idea_group_list,//转化出价
              title: crossProductForm.title,//广告标题
              config_json: JSON.stringify({
                  config: {
                    add_type: this.addType,
                  },
                  createInfoForm,
                  advertGroupForm,
                  advertCreatForm,
                  crossProductForm
                })
            };
            if (this.dataId) {
              params.copy_id = this.dataId;
            }
            try {
              const result = await API.postBatchPreview(params, {timeout: 120 * 1000});
              this.$emit("changePage", "previewPage",
                result.data.task_id,
                cloneDeep({
                  config: {
                    add_type: this.addType,
                    task_id: result.data.task_id
                  },
                  createInfoForm,
                  advertGroupForm,
                  advertCreatForm, crossProductForm
                })
              )
            } catch (error) {
              this.errorFormList = [error.info];
              this.popoverVisible = true
              // this.$message.error(error.info || '创建失败，请检查')
              console.log(error,'error');
            }finally {
               this.previewLoading = false
            }

          }).catch((err)=> {
            console.log(err,'errerr');
            this.popoverVisible = true
            this.previewLoading = false
          })
      },
     // 提示信息
    showMessageTip(b,tip) {
      if (!b) {
        return
      }
      this.$alert(tip, '提示', {
        confirmButtonText: '确定',
        callback: action => { }
      });
    },
    // 设置提示信息触发类型和条件
    rulesCb(item) {
      switch (item.param_name) {
        // case '转化类型':
        //   const cb = (value)=> {
        //     const { planName, adgroupName }  = this;
        //     const key = '{转化类型}'
        //     const b = (planName.indexOf(key)>-1 || adgroupName.indexOf(key)>-1)&&!value
        //     this.showMessageTip(b, this.TIP_DATA.CV_TIP);
        //   };
        //   item.cb = cb;
        //   break;

        default:
          item.cb = new Function();
          break;
      }
    },
    // 设置提示信息触发类型和条件
    nameCb(item) {
      switch (item.param_name) {
        // case '转化类型':
        //   const cb = ()=> {
        //     this.showMessageTip( !this.planAllocationRules.includes('union_conver_type') ,this.TIP_DATA.CV_TIP);
        //   };
        //   item.cb = cb;
        //   break;

        default:
          item.cb = new Function();
          break;
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getFixWidth)
  }
}
</script>

<style lang="scss" scoped>
.create-page {
  background-color: #F1F4F9;
  &::v-deep {
    .tip_box .el-form-item__error {
      padding-top: 12px;
    }
  }
}

.content-box {
  min-height: 800px;
  background-color: #fff;
  // margin-top: 80px;
  padding: 10px 40px 10px 40px;
}
.mi_create_header_fixed{
  position: fixed;
  z-index: 2;
  top: 50px;
  // box-shadow: 0px 1px 2px #d9d9d9;
  // border-bottom: 10px solid #F1F4F9;
    border-bottom: solid 1px #eee;
  &.header{
    font-size: 14px;
    background-color: #fff;
    .close {
      color: #555;
      cursor: pointer;
      font-size: 14px;
      font-weight: 600;
      padding-right: 20px;
      cursor: pointer;
    }
    >.tip {
      color: #000;
      font-size: 14px;
      font-weight: 600;
      padding-left: 20px;
      padding-right: 20px;
      cursor: pointer;
    }
  }
}
.tip-list {
  .btn {
    text-align: center;
    margin-top: 12px;
    span {
      padding: 0 12px;
    }
  }
}
</style>
